import React, { useState } from 'react';
import ReactTable from 'react-table'

const AdminPurchaseOrderItemsTable = props => {
    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 75,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'ID BARANG',
        accessor: 'id',
    },{
        Header: 'NAMA BARANG',
        accessor: 'name',
    },{
        Header: 'SKU',
        accessor: 'sku',
    },{
        Header: 'DETAIL',
        accessor: 'details',
    },{
        Header: 'JUMLAH',
        accessor: 'quantity',
    }];

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={5}
                filterable
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default AdminPurchaseOrderItemsTable;
